export default "/images/a0cfdeb84845011da9efd039ff120a23.avif";